import { FunctionComponent, HTMLAttributes, ReactNode } from 'react';
import cn from '../cn';

type TableRowUIProps = {
  children?: ReactNode,
} & HTMLAttributes<HTMLTableRowElement>;

// Row. Zebra striping and hover come from `.ds-table tbody tr` in
// design-system.css, not from the ~60 call sites that used to recompute
// `index % 2 ? 'bg-black/[0.04]' : ''` each. Centralising it also made striping
// theme-aware — the old literal black wash was invisible on a dark surface.
//
// Call-site classNames still compose and still win, so a row that needs a
// meaningful background (a status colour) can override freely.
const TableRowUI: FunctionComponent<TableRowUIProps> = ({ className = '', children, ...rest }) => (
  <tr
    className={cn(className)}
    {...rest}
  >
    {children}
  </tr>
);

export default TableRowUI;
